import { useMemo } from 'react';
import { useAppSelector } from '../../../hooks/redux';
import type { PaymentIntentBootstrapDataSnapshot } from '../../interfaces';
import { getCartValidationIssues } from '../../../utils/cartValidation';
import {
  createPaymentIntentRequestKey,
  getCartMaterialDataByItemId,
} from './paymentIntentBootstrap.helpers';

export const usePaymentIntentBootstrapData = (): PaymentIntentBootstrapDataSnapshot => {
  const cartItems = useAppSelector((state) => state.shoppingCart.cartItems);
  const user = useAppSelector((state) => state.user.user);
  const userShipping = useAppSelector((state) => state.user.shipping);
  const guestEmail = useAppSelector((state) => state.shoppingCart.guestEmail);
  const guestShipping = useAppSelector((state) => state.shoppingCart.guestShippingAddress);
  const materialPriceAndImgForCart = useAppSelector(
    (state) => state.shoppingCart.materialPriceAndImgForCart
  );
  const shipping = user?.id ? userShipping : guestShipping;
  const isGuestCheckout = !user?.id;
  const materialDataByItemId = useMemo(
    () => getCartMaterialDataByItemId(materialPriceAndImgForCart),
    [materialPriceAndImgForCart]
  );
  const cartValidationIssues = useMemo(
    () => getCartValidationIssues(cartItems, materialDataByItemId),
    [cartItems, materialDataByItemId]
  );
  const paymentRequestKey = useMemo(
    () =>
      createPaymentIntentRequestKey({
        cartItems,
        shipping,
        guestEmail,
        isGuestCheckout,
      }),
    [
      cartItems,
      shipping,
      guestEmail,
      isGuestCheckout,
    ]
  );

  return {
    cartItems,
    userId: user?.id,
    shipping,
    guestEmail,
    cartValidationIssues,
    paymentRequestKey,
  };
};
